import Vue from "vue";
import store from "@/store";

export async function refreshParticipants(lead_identifier_code) {
  const lead = store.state.lead;

  const response = await Vue.prototype.$http.get("/participants", {
    params: {
      paginate: false,
      lead_identifier_code
    }
  });

  const participants = response.data;

  store.commit("setLead", {
    ...store.state.lead,
    participants
  });
}

export async function changeStatus(lead_id, status_id) {
  const response = await Vue.prototype.$http.post("/leads/change_status", {
    lead_id,
    status_id
  });

  return response.data;
}

export async function getLeadStatuses() {
  const response = await Vue.prototype.$http.get("/lead_statuses");

  return response.data;
}

export async function approveLead(
  lead_id,
  approved,
  approve_justification = null
) {
  const response = await Vue.prototype.$http.post("/leads/approve", {
    lead_id,
    approved,
    approve_justification
  });

  return response.data;
}

export async function my_leads(params) {
  const response = await Vue.prototype.$http.get(`/my_leads`, {
    params
  });

  return response.data;
}

export async function indexUnities(lead_number, team_id) {
  const response = await Vue.prototype.$http.get(`/leads/${lead_number}/unities`, {
    params: { team_id }
  });

  return response.data;
}

export async function getStatusHistory(lead_id) {
  const response = await Vue.prototype.$http.get(
    `/leads/${lead_id}/status_history`
  );

  return response.data;
}

export async function change_manager(lead_id, payload) {
  const response = await Vue.prototype.$http.put(
    `/leads/${lead_id}/change_manager`,
    payload
  );

  return response.data;
}

export async function change_unity(lead_id, payload) {
  const response = await Vue.prototype.$http.put(
    `/leads/${lead_id}/change_unity`,
    payload
  );

  return response.data;
}

export async function change_team(lead_id, team_id) {
  const response = await Vue.prototype.$http.put(
    `/leads/${lead_id}/team`,
    {
      team_id
    }
  );

  return response;
}